export const delay = (wait: number = 0) => {
  return new Promise((resolve) => {
    setTimeout(resolve, wait);
  });
};
